import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useRegisterPageView } from '../../lib/api/hooks/mutations/Analytics/useRegisterPageView';

type Props = {
	pageReference: string;
};

export default function AnalyticsTracker({ pageReference }: Props) {
	const { mutate } = useRegisterPageView();
	let { pathname } = useRouter();

	useEffect(() => {
		mutate({ url: pathname, reference: pageReference });
	}, [pageReference, pathname, mutate]);

	return null;
}
